import {useNavigationBlocker} from '@hconnect/common/hooks'
import {Loader} from '@hconnect/uikit/src/lib2'
import {useMemo} from 'react'

import {useGetAssetConfig, useGetAssetConfigs, useGetKilnInfo, useGetPlantUpmId} from '../../api'
import {assetToSignals, useUrlParam} from '../../hooks'
import {KilnConfigProvider} from '../../providers'
import {AssetConfigurationDto} from '../../types'

import {ConfirmNavigationDialog} from './common'
import {KilnConfigContent} from './KilnConfigContent'

export const KilnConfig = () => {
  const kilnId = useUrlParam('kilnId')

  const {isBlocked, setIsBlockActive, handleClose, bypassNavigationBlocker} = useNavigationBlocker()

  const {isLoading: isUpmLoading, data: upmPlant} = useGetPlantUpmId()
  const {isLoading: isConfigLoading, data: assetConfig, error} = useGetAssetConfig(kilnId)

  const {data: kilns} = useGetKilnInfo(upmPlant?.upmId)
  const otherKilns = useMemo(
    () => (kilns ? kilns.filter((k) => k.id !== kilnId) : []),
    [kilnId, kilns]
  )
  const {data: otherSignals} = useGetAssetConfigs(otherKilns.map((k) => k.id))

  const disabledSignals = otherSignals
    .map((config) => assetToSignals(config as unknown as AssetConfigurationDto))
    .flat()

  const isPageLoading = isConfigLoading || isUpmLoading

  const isConfigMissing = !isPageLoading && (error?.response?.status === 404 || !assetConfig)

  if (isPageLoading) {
    return <Loader color="grey" height="60vh" />
  }

  return (
    <KilnConfigProvider assetConfig={assetConfig}>
      {isBlocked && (
        <ConfirmNavigationDialog handleClose={handleClose} setIsBlockActive={setIsBlockActive} />
      )}
      <KilnConfigContent
        kilnId={kilnId}
        isConfigMissing={isConfigMissing}
        disabledSignals={disabledSignals}
        bypassNavigationBlocker={bypassNavigationBlocker}
      />
    </KilnConfigProvider>
  )
}
